import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey('CompanyName=LARSEN & TOUBRO LIMITED,LicensedGroup=L&T EduTech,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=2,AssetReference=AG-029335,SupportServicesEnd=15_July_2023_[v2]_MTY4OTM3NTYwMDAwMA==ea975a8ce95adb8389ad0ea402c73b57');
global.agGrid = global.agGrid = require('ag-grid-enterprise');

// AG Grid functionalities
let gridOptions, gridListDiv;

let filterParams = {
    comparator: (filterLocalDateAtMidnight, cellValue) => {
        let dateAsString = cellValue;
        if (dateAsString == null) return -1;

        dateAsString = dateAsString.replace(/st/g, '').replace(/nd/g, '').replace(/rd/g, '').replace(/th/g, '');
        dateAsString = new Date(dateAsString);

        let month = dateAsString.getMonth();
        month = month.toString();
        let day = dateAsString.getDate().toString();
        let year = dateAsString.getFullYear().toString();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        let cellDate = new Date(Number(year), Number(month), Number(day));

        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
            return 0;
        }

        if (cellDate < filterLocalDateAtMidnight) {
            return -1;
        }

        if (cellDate > filterLocalDateAtMidnight) {
            return 1;
        }
        return 0;
    },
};

class CustomDateComponent {
    init(params) {
        const template = `<input type="text" data-input style="width: 100%;" placeholder="DD-MM-YYYY" />
                <a class="input-button" title="clear" data-clear>
                    <i class="fa fa-times"></i>
                </a>`;

        this.params = params;

        this.eGui = document.createElement('div');
        this.eGui.setAttribute('role', 'presentation');
        this.eGui.classList.add('ag-input-wrapper');
        this.eGui.classList.add('custom-date-filter');
        this.eGui.innerHTML = template;

        this.eInput = this.eGui.querySelector('input');

        this.picker = flatpickr(this.eGui, {
            onChange: this.onDateChanged.bind(this),
            dateFormat: 'd/m/Y',
            wrap: true,
        });

        this.picker.calendarContainer.classList.add('ag-custom-component-popup');

        this.date = null;
    }

    getGui() {
        return this.eGui;
    }

    onDateChanged(selectedDates) {
        this.date = selectedDates[0] || null;
        this.params.onDateChanged();
    }

    getDate() {
        return this.date;
    }

    setDate(date) {
        this.picker.setDate(date);
        this.date = date;
    }

    setInputPlaceholder(placeholder) {
        this.eInput.setAttribute('placeholder', placeholder);
    }
}

let numberValueFormatter = function (params) {
    return Number(params.value).toFixed(2);
};

let cellRendererSelector = (params) => {
    const htmlDetails = {
        component: HtmlRenderer
    };
    if (params.data) {
        return htmlDetails;
    }
    return undefined;
};

class CustomTooltip {
    init(params) {
        const type = params.type || 'primary';
        const data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
        const eGui = (this.eGui = document.createElement('div'));
        // eGui.classList.add('custom-tooltip');
        if (data.count) {
            this.eGui.innerHTML = `<p class="alert alert-success text-decoration-none m-1 p-1">View Submissions</p>`;
        }
    }

    getGui() {
        return this.eGui;
    }
}

class HtmlRenderer {
    init(params) {
        this.eGui = document.createElement('span');
        this.eGui.innerHTML = params.value;
    }
    getGui() {
        return this.eGui;
    }
    refresh(params) {
        return false;
    }
}

// Custom cell renderer function for formatting the date
function dateCellRenderer(params) {
    let date = params.value; // Assuming the "created_at" field contains the date value

    if (date) {
        let formattedDate = formatDate(date); // Custom date formatting function
        return formattedDate;
    }
    return null;
}

function formatDate(date) {
    // Custom date formatting logic
    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(date).toLocaleDateString(undefined, options);
}

// Custom cell renderer function for Bootstrap tooltip
function bootstrapTooltipCellRenderer(params) {
    let cellValue = params.value;
    let tooltipText = 'Tooltip: ' + cellValue;

    let cellElement = document.createElement('div');
    cellElement.classList.add('bootstrap-tooltip');
    cellElement.setAttribute('data-bs-toggle', 'tooltip');
    cellElement.setAttribute('data-bs-placement', 'top');
    cellElement.setAttribute('title', tooltipText);
    cellElement.textContent = cellValue;

    return cellElement;
}

// Enable Bootstrap tooltips on cell render
function enableBootstrapTooltips() {
    let tooltipTriggerList = [].slice.call(document.querySelectorAll('.bootstrap-tooltip'));
    tooltipTriggerList.forEach(function (tooltipTriggerEl) {
        new bootstrap.Tooltip(tooltipTriggerEl);
    });
}

let manuallySelectedIds = new Set();
let lastFilterModel = null;
let isConfirming = false;

// Callback function to execute after grid is ready
function onGridReady(params) {
    enableBootstrapTooltips();

    // ✅ Fit columns to grid width
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 100);

    // ✅ Resize on window resize
    window.addEventListener('resize', function () {
        setTimeout(() => {
            params.api.sizeColumnsToFit();
        }, 200);
    });

    // Track manual selection
    params.api.addEventListener('rowSelected', onRowSelected);

    // Listen to filter
    params.api.addEventListener('filterChanged', onFilterChanged);
}

function onRowSelected(event) {
    const id = event.data?.entry_id;
    if (!id) return;

    if (event.node.isSelected()) {
        manuallySelectedIds.add(id);
    } else {
        manuallySelectedIds.delete(id);
    }
}

function onFilterChanged(params) {
    setTimeout(() => {
        if (isConfirming) return;

        const api = params.api;
        const currentFilterModel = api.getFilterModel();

        // Get filtered rows
        let filteredRowIds = [];
        api.forEachNodeAfterFilter(node => {
            filteredRowIds.push(node.data.entry_id);
        });

        // Check if any selected row is filtered out (selected but not visible)
        const selectedButNotVisible = [...manuallySelectedIds].some(id => !filteredRowIds.includes(id));

        if (selectedButNotVisible) {
            isConfirming = true;

            Swal.fire({
                title: 'Your selection includes rows not in the filtered data. Reset selection?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, reset',
                cancelButtonText: 'No, keep selection',
                allowOutsideClick: false,
                customClass: {
                    confirmButton: 'btn btn-warning me-2',
                    cancelButton: 'btn btn-secondary'
                },
            }).then(result => {
                if (result.isConfirmed) {
                    // Clear selection and Set
                    manuallySelectedIds.clear();
                    api.deselectAll();
                    lastFilterModel = currentFilterModel;
                } else {
                    // revert filter back to last one to keep selection stable
                    api.setFilterModel(lastFilterModel);
                }
                isConfirming = false;
            });
        } else {
            // No problem with selection, update lastFilterModel
            lastFilterModel = currentFilterModel;
        }
    }, 0); // minimal delay to allow grid to update selections
}

if ($('#jn-dd').length) {
    $('#jn-dd').change(function (e) {
        e.preventDefault();
        let changedValue = $(this).val();
        if (changedValue != '' && changedValue !== undefined) {
            let origin = location.origin;
            let pathname = location.pathname;
            let parts = pathname.split('/')
            // change segments  
            // console.log('pathname ', parts);
            // console.log('parts ', location);
            if (parts.length >= 3) {
                parts[parts.length - 1] = changedValue;
            } else {
                parts[parts.length] = changedValue;
            }
            let new_url = origin + parts.join('/')
            window.location.href = new_url;
        }
    });
}

if ($('#filter-notifications-dd').length) {

    let selectedNotificationSlug = localStorage.getItem("notificationSlug")?? '';
    let selectedNotificationName = localStorage.getItem("notificationName") ?? '';

    if(selectedNotificationSlug != '') {
        $('#filter-notifications-dd').val(selectedNotificationSlug).trigger('change');
        $('#notificationName').text(` : ${selectedNotificationName}`);
    }


    $('#filter-notifications-dd').change(function (e) {
        e.preventDefault();
        let changedValue = $(this).val();
        let changedLabel = $(this).find("option:selected").text();
        if (changedValue != '' && changedValue !== undefined) {

            localStorage.setItem("notificationSlug", changedValue);
            localStorage.setItem("notificationName", changedLabel);

            let origin = location.origin;
            let pathname = location.pathname;
            let parts = pathname.split('/')
            
            if (parts[1] === 'course-preferences') {
                if (parts.length >= 5) {
                    parts[parts.length - 1] = changedValue;
                } else {
                    parts[parts.length] = changedValue;
                }
            } else {
                if (parts.length >= 4) {
                    parts[parts.length - 1] = changedValue;
                } else {
                    parts[parts.length] = changedValue;
                }
            }
            let new_url = origin + parts.join('/')
            window.location.href = new_url;
        }
    });
}

if ($('#agGrid').length) {
    let dataArray = window?.gridData ?? [];
    const replacedArray = dataArray.map(obj => {
        const replacedObj = {};
        for (let key in obj) {
            // if (key == "created_at") {
            //     // Parse the input time string into a Date object
            //     let parsedTime = new Date(obj[key]);
            //     // Calculate the new time by adding 5 hours and 30 minutes
            //     parsedTime.setHours(parsedTime.getHours() + 5);
            //     parsedTime.setMinutes(parsedTime.getMinutes() + 30);
            //     // Format the new time into the desired string format
            //     let formattedNewTime = parsedTime.toLocaleString('en-US', {
            //         day: 'numeric',
            //         month: 'short',
            //         year: 'numeric',
            //         hour: 'numeric',
            //         minute: 'numeric',
            //         hour12: true
            //     });
            //     obj[key] = formattedNewTime
            // }
            if (key == 'haveYouDone12ThOrDiplomaPleaseSelectAsApplicable') {
                let sortedvalue = JSON.parse(obj[key])
                if (sortedvalue.hsc && sortedvalue.diploma) {
                    obj[key] = '12th,Diploma'
                } else if (sortedvalue.hsc && !sortedvalue.diploma) {
                    obj[key] = '12th'
                } else if (sortedvalue.diploma && !sortedvalue.hsc) {
                    obj[key] = 'Diploma'
                } else if (sortedvalue.hsc) {
                    obj[key] = '12th'
                } else if (sortedvalue.diploma) {
                    obj[key] = 'Diploma'
                }

            }
            if (key === 'formSubmissionStatus' || key === 'paymentStatus') {
                replacedObj[key] = obj[key] === null ? "" : obj[key].charAt(0).toUpperCase() + obj[key].slice(1);
            } else {
                replacedObj[key] = obj[key] === 'null' ? "" : obj[key];
            }
        }
        return replacedObj;
    });
    dataArray = replacedArray
    let columnDefs = window?.gridWrapper ?? [];
    let gridRowSelection = window?.gridRowSelection ?? false;
    for (let columnDef of columnDefs) {
        if (columnDef.cellRendererSelector) {
            columnDef.cellRendererSelector = cellRendererSelector;
        }
        if (columnDef.filterParams && typeof columnDef.filterParams == "boolean") {
            columnDef.filterParams = filterParams;
        }
        if (columnDef.valueFormatter) {
            columnDef.valueFormatter = numberValueFormatter;
        }
        if (columnDef.field == 'count') {
            columnDef.cellRendererSelector = cellRendererSelector;
        }
        if (columnDef.field == 'duplicate_records') {
            columnDef.cellRendererSelector = cellRendererSelector;
        }
        if (columnDef.field == 'status') {
            columnDef.cellRendererSelector = cellRendererSelector;
        }
        // if(columnDef.field == 'role') {
        //     columnDefs[2].cellClassRules = ragCellClassRules;
        //     columnDefs[2].cellRenderer = ragRenderer;
        // }
        if (columnDef.field == 'applicationFormUrl' || columnDef.field == 'action') {
            columnDef.cellRendererSelector = cellRendererSelector;
        }
    }

    gridOptions = {
        rowData: null,
        rowSelection: gridRowSelection,
        suppressRowClickSelection: false,
        columnDefs: columnDefs,
        onGridReady: onGridReady,
        suppressCsvExport: false,
        suppressExcelExport: false,
        // Right-click menu
        getContextMenuItems: function (params) {
            return [
                'copy',
                'copyWithHeaders',
                'separator',
                {
                    name: 'Export to CSV',
                    action: function () {
                        params.api.exportDataAsCsv();
                    }
                },
                {
                    name: 'Export to Excel',
                    action: function () {
                        params.api.exportDataAsExcel();
                    }
                }
            ];
        },
        enableCharts: true,
        components: {
            agDateInput: CustomDateComponent,
            dateCellRenderer: dateCellRenderer
        },
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            floatingFilter: true,
            flex: 1,          // ✅ KEY FIX
            minWidth: 120     // ✅ Prevent collapse
        },
        sideBar: {
            toolPanels: [{
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {},
            },
            {
                id: 'filters',
                labelDefault: 'Filters',
                labelKey: 'filters',
                iconKey: 'filter',
                toolPanel: 'agFiltersToolPanel',
                toolPanelParams: {},
            }
            ]
        },
        pagination: true,
        paginationPageSize: 10,
        onFirstDataRendered: onFirstDataRendered,
        paginationNumberFormatter: (params) => {
            return params.value.toLocaleString();
        },
    };
    if (columnDefs.length < 6) {
        gridOptions.defaultColDef.flex = 1;
    }

    function onPageSizeChanged() {
        let value = document.getElementById('page-size').value;
        gridOptions.api.paginationSetPageSize(Number(value));
    }

    function onFirstDataRendered(params) {
        // ✅ Fit after data loads
        setTimeout(() => {
            params.api.sizeColumnsToFit();
        }, 100);

        let eGridDiv = document.querySelector("#agGrid");
        let paginationPanel = eGridDiv.querySelector(".ag-paging-panel");

        let selectElement = document.createElement("select");
        selectElement.id = "page-size";
        selectElement.className = "form-select form-select-sm ms-2";
        selectElement.onchange = onPageSizeChanged;

        let pageSizes = [10, 100, 500, 1000];

        pageSizes.forEach(function (pageSize) {
            let option = document.createElement("option");
            option.value = pageSize;
            option.text = pageSize;
            if (pageSize === gridOptions.paginationPageSize) {
                option.selected = true;
            }
            selectElement.appendChild(option);
        });

        let container = document.createElement("span");
        container.className = "d-flex align-items-center";

        let label = document.createElement("span");
        label.innerHTML = "Per Page";
        label.className = "me-2 small text-muted";

        container.appendChild(label);
        container.appendChild(selectElement);

        paginationPanel.insertBefore(container, paginationPanel.firstChild);
    }

    //date filter for dob
    if (gridOptions.columnDefs[5] && gridOptions.columnDefs[5].field == 'dob')
        gridOptions.columnDefs[5].filterParams = filterParams;

    gridOptions.rowData = dataArray
    gridListDiv = document.getElementById("agGrid");
    new agGrid.Grid(gridListDiv, gridOptions);
    if (typeof window.AG_GRID_LICENSE_KEY !== 'undefined') {
        agGrid.LicenseManager.setLicenseKey(window.AG_GRID_LICENSE_KEY);
    }

    function onBtForEachNodeAfterFilterAndSort() {
        let token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        //get filterColumn from ag-grid
        let filterModel = gridOptions.api.getFilterModel();
        //get sorted value from ag-grid
        let columnState = gridOptions.columnApi.getColumnState()
        //sort column start
        let column = columnState.filter((item, index) => {
            if (item.sort != null) {
                return item
            }
        })
        if (column.length == 0) {
            let sortKey = ""
            let sortValue = ""
        } else {
            let sortKey = column[0].colId
            let sortValue = column[0].sort
        }
        //sort column end
        let data = []
        const entries = Object.entries(filterModel);
        if (column.length == 0 && entries.length == 0) {
            data = []
        } else if (entries.length == 0 && column.length != 0) {
            let filter = {
                sortparams: sortKey,
                sortfilter: sortValue
            }
            data.push(filter)
        } else if (entries.length != 0 && column.length == 0) {
            entries.forEach(([key, value]) => {
                if (key == 'title') {
                    key = 'definition->title'
                }
                let filter = {
                    inputparams: key,
                    filterType: value.filterType,
                    type: value.type,
                    filter: value.filter,
                    sortparams: "",
                    sortfilter: ""
                }
                data.push(filter)
            });
        } else if (entries.length != 0 && column.length != 0) {
            entries.forEach(([key, value]) => {
                if (key == 'title') {
                    key = 'definition->title'
                }
                let filter = {
                    inputparams: key,
                    filterType: value.filterType,
                    type: value.type,
                    filter: value.filter,
                    sortparams: sortKey,
                    sortfilter: sortValue
                }
                data.push(filter)
            });
        }
        $.ajax({
            url: 'form-submissions/generatecsv',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            success: function (response) {
                // create an empty array for CSV data
                const csvData = [];
                // push the header row to csvData
                csvData.push(Object.keys(response[0]));
                // loop through each object and convert it to an array of values
                response.forEach((obj) => {
                    const row = Object.values(obj);
                    csvData.push(row);
                });
                // convert csvData to a CSV string
                const csvString = csvData.map((row) => row.join(",")).join("\n");
                // create a Blob from the CSV string
                const blob = new Blob([csvString], {
                    type: "text/csv;charset=utf-8;"
                });
                // create a temporary link element to download the file
                const link = document.createElement("a");
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", "data.csv");
                // trigger a click event on the link to download the file
                link.click();
            }
        });
    }

    window.exportCSV = function () {
        // Get the column API
        let columnApi = gridOptions.columnApi;
        // Store the current state of the action columns
        let actionColumns = [];

        dataArray.forEach((item, index) => {
            if (item.count) {
                item.count = item.count.replace(/<[^>]+>/g, "")
            }
            for (const key in item) {
                if (item.hasOwnProperty(key)) {
                    const imgRegex = /<img.*?src=["'](.*?)["']/;
                    const anchorRegex = /<a.*?href=["'](.*?)["']/;
                    const imgMatches = typeof item[key] === 'string' && item[key].match(imgRegex) ? item[key].match(imgRegex) : [];
                    const anchorMatches = typeof item[key] === 'string' && item[key].match(anchorRegex) ? item[key].match(anchorRegex) : [];
                    if (imgMatches.length) {
                        item[key] = imgMatches[1] ?? '';
                    } else if (anchorMatches.length) {
                        item[key] = anchorMatches[1] ?? '';
                    } else {
                        item[key] = item[key] === null ? "" : item[key];
                    }
                }
            }

        })
        // Exclude action columns from export
        const exportableColumns = columnApi.getColumns()
            .filter(col => !['action', 'actions'].includes(col.getColId()))
            .map(col => col.getColId());

        // Export data as CSV
        gridOptions.suppressExcelExport = true;
        gridOptions.suppressCsvExport = false;

        const pathname = window.location.pathname;
        // const csvFileName = pathname.split('/');

        let parts = window.location.pathname.split('/').filter(Boolean);
        let originalString = parts.pop() || 'Report';
        // Safe fallback

        // Now safe to use split
        let transformedResult = originalString.split(/[-\s]/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

        let currentDate = new Date();
        let year = currentDate.getFullYear();
        let month = currentDate.toLocaleString('default', { month: 'short' });

        let currentTime = currentDate.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });

        const convertedTime = currentTime.replace(/ /g, '_');

        let fileName = `${transformedResult}_${year}_${month}_${currentDate.getDate()}_${convertedTime}`;

        let params = {
            fileName: fileName,
            columnKeys: exportableColumns,
        };

        gridOptions.api.exportDataAsCsv(params);
    };

    window.syncCoursePreferenceData = function () {
        // Get the column API
        let columnApi = gridOptions.columnApi;
        // Store the current state of the action columns
        let actionColumns = [];

        dataArray.forEach((item, index) => {
            if (item.count) {
                item.count = item.count.replace(/<[^>]+>/g, "")
            }
            for (const key in item) {
                if (item.hasOwnProperty(key)) {
                    const imgRegex = /<img.*?src=["'](.*?)["']/;
                    const anchorRegex = /<a.*?href=["'](.*?)["']/;
                    const imgMatches = typeof item[key] === 'string' && item[key].match(imgRegex) ? item[key].match(imgRegex) : [];
                    const anchorMatches = typeof item[key] === 'string' && item[key].match(anchorRegex) ? item[key].match(anchorRegex) : [];
                    if (imgMatches.length) {
                        item[key] = imgMatches[1] ?? '';
                    } else if (anchorMatches.length) {
                        item[key] = anchorMatches[1] ?? '';
                    } else {
                        item[key] = item[key] === null ? "" : item[key];
                    }
                }
            }

        })
        columnApi.getColumns().forEach(function (column) {
            if (column.colId === 'action' || column.colId === 'actions') {
                actionColumns.push(column);
            }
        });
        // Hide the action columns
        columnApi.setColumnsVisible(actionColumns, false);
        // Export data as CSV
        gridOptions.suppressExcelExport = true;
        gridOptions.suppressCsvExport = false;
        const pathname = window.location.pathname;
        const csvFileName = pathname.split('/');
        let originalString = csvFileName[2];
        let transformedResult = originalString.split(/[-\s]/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        let currentDate = new Date();
        let year = currentDate.getFullYear();
        let month = currentDate.toLocaleString('default', { month: 'short' });
        let currentTime = currentDate.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });
        const convertedTime = currentTime.replace(/ /g, '_');
        let fileName = transformedResult + `_${year}_${month}_${currentDate.getDate()}_${convertedTime}`;
        let params = {
            fileName: fileName
        };

        gridOptions.api.exportDataAsCsv(params);
        // gridOptions.api.exportDataAsExcel()
        // Show the action columns again
        columnApi.setColumnsVisible(actionColumns, true);
    };

    function exportToCSVFromAgGrid() {
        const columnDefs = gridOptions.columnApi.getColumns().map(col => col.getColDef());
        const actionColumns = []; // To store specific columns like 'action' or 'actions'

        // Filter visible columns and handle 'action' or 'actions' columns
        const visibleColumns = columnDefs.filter(col => {
            if (col.field === 'action' || col.field === 'actions') {
                actionColumns.push(col); // Collect action columns separately
                return false; // Exclude them from the CSV
            }
            return !col.hide; // Include only visible columns
        });

        const headers = visibleColumns.map(col => col.headerName || col.field); // Extract headers

        // Get row data from AG Grid
        const rowData = [];
        gridOptions.api.forEachNodeAfterFilterAndSort(node => rowData.push(node.data));

        // Prepare CSV rows
        const csvRows = [];
        csvRows.push(headers.join(',')); // Add headers

        // Regex for handling <img> and <a> tags
        const imgRegex = /<img.*?src=["'](.*?)["']/;
        const anchorRegex = /<a.*?href=["'](.*?)["']/;

        // Process each row of data
        rowData.forEach(row => {
            const rowValues = visibleColumns.map(col => {
                const field = col.field; // Field name from column definition
                let cell = row[field] || ''; // Get cell value

                // Handle <img> and <a> tags
                if (typeof cell === 'string') {
                    const imgMatch = cell.match(imgRegex);
                    const anchorMatch = cell.match(anchorRegex);
                    if (imgMatch) {
                        cell = imgMatch[1]; // Extract src from <img>
                    } else if (anchorMatch) {
                        cell = anchorMatch[1]; // Extract href from <a>
                    }
                    cell = cell.replace(/<[^>]+>/g, ''); // Strip any other HTML tags
                }

                // Escape commas and quotes
                if (typeof cell === 'string' && (cell.includes(',') || cell.includes('"'))) {
                    cell = `"${cell.replace(/"/g, '""')}"`;
                }

                return cell;
            });
            csvRows.push(rowValues.join(',')); // Add processed row to CSV
        });

        // // Combine all rows into a CSV string
        const csvContent = csvRows.join('\n');

        // Create a Blob and trigger the download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const pathname = window.location.pathname;
        const csvFileName = pathname.split('/');
        let originalString = csvFileName[2];
        let transformedResult = originalString.split(/[-\s]/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        let currentDate = new Date();
        let year = currentDate.getFullYear();
        let month = currentDate.toLocaleString('default', { month: 'short' });
        let currentTime = currentDate.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });
        const convertedTime = currentTime.replace(/ /g, '_');
        let fileName = `${transformedResult}_${year}_${month}_${currentDate.getDate()}_${convertedTime}`;

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function exportExcel() {
        let fileName = $("title").text().trim(); // Replace with your custom file name
        let params = {
            fileName: fileName + Date.now()
        };
        gridOptions.suppressExcelExport = true;
        gridOptions.suppressCsvExport = false;
        gridOptions.api.exportDataAsCsv(params);
    }

    function printTable() {
        const api = gridOptions.api;
        setPrinterFriendly(api);
        setTimeout(function () {
            print();
            setNormal(api);
        }, 2000);
    }

    function setPrinterFriendly(api) {
        const eGridDiv = document.querySelector('#agGrid');
    }

    function setNormal(api) {
        const eGridDiv = document.querySelector('#agGrid');
        api.setDomLayout();
    }
} else {
    // console.log("Element with ID 'agGrid' does not exist.");
}

if ($('#form-master-dd').length) {
    $('#form-master-dd').change(function (e) {
        e.preventDefault();
        let changedValue = $(this).val();
        if (changedValue != '' && changedValue !== undefined) {
            let url = location.href;
            let parts = url.split('/')
            // change segments  
            parts[parts.length - 1] = changedValue;
            let new_url = parts.join('/')
            window.location.href = new_url;
        }
    });
}

$('body').on('click', '.deleteEle', function () {
    Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
        if (result.value) {
            let dataUrl = $(this).attr("data-url");
            $.ajax({
                url: dataUrl,
                method: "GET",
                success: function (res) {
                    Swal.fire({
                        title: 'Deleted!',
                        text: 'Record deleted successfully!',
                        icon: 'success'
                    }).then(() => {
                        window.location.reload(true);
                    });
                }
            });
        }
    });
});

$('body').on('click', '.syncStatusRow', function () {
    Swal.fire({
        title: 'Are you sure want to update this status?',
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, confirm!'
    }).then((result) => {
        if (result.value) {
            let dataUrl = $(this).attr("data-url");
            $.ajax({
                url: dataUrl,
                method: "GET",
                success: function (res) {
                    Swal.fire({
                        title: 'Synced!',
                        text: res?.message ?? 'Payment link synced successfully!',
                        icon: 'success'
                    }).then(() => {
                        window.location.reload(true);
                    });
                }
            });
        }
    });
});

$('body').on('click', '#sync-course-preference-data', function () {
    Swal.fire({
        title: 'Sync Course Preference Data',
        text: "Are you sure you want to sync the latest course preference data from the application form submissions?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, confirm!',
        allowOutsideClick: false,
        customClass: {
            confirmButton: 'btn btn-success me-2',
            cancelButton: 'btn btn-secondary'
        },
    }).then((result) => {
        if (result.value) {
            let dataUrl = $(this).attr("data-url");
            let jobNotificationId = $(this).attr('data-notification-id');
            let postData = { 'jobNotificationId': jobNotificationId };
            $(this).attr('disabled', 'disabled');
            $(this).html('Syncing');
            $.ajax({
                url: dataUrl,
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(postData),
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                success: function (res) {
                    $(this).html('Sync');
                    let responseMessage = res?.message ?? 'The required data synced successfully!';
                    let counts = res?.count ?? {};
                    responseMessage += "<br> <b>Candidate(s) Count : </b> " + (counts?.candidates_count ?? 0);
                    responseMessage += "<br> <b>Course Preference(s) Count : </b> " + (counts?.courses_count ?? 0);
                    if (counts?.candidates_count <= 0) {
                        responseMessage = 'No data found to sync for the academic approvals.';
                    }
                    Swal.fire({
                        title: 'Synced!',
                        html: responseMessage,
                        icon: 'success'
                    }).then(() => {
                        window.location.reload(true);
                    });
                }
            });
        }
    });
});

//clone
$('body').on('click', '.cloneElement', function () {
    Swal.fire({
        title: 'Are you sure to Clone?',
        text: "",
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Clone it!'
    }).then((result) => {
        if (result.value) {
            let dataUrl = $(this).attr("data-url");
            $.ajax({
                url: dataUrl,
                method: "GET",
                success: function (res) {
                    Swal.fire({
                        title: 'Cloned!',
                        text: 'Record Cloned successfully!',
                        icon: 'success'
                    }).then(() => {
                        window.location.reload(true);
                    });
                }
            });
        }
    });
});

$('body').on('click', '.take-action-drawer, .view-candidate-drawer', function (e) {
    e.preventDefault();

    const actionId = $(this).data('action-id');
    const fetchDataUrl = $(this).data('fetch-url');
    const actionType = $(this).data('action-type') ?? '';

    // Select each section by ID
    const $header = $('#takeActionDrawerHeader');
    const $body = $('#takeActionDrawerBody');
    const $footer = $('#takeActionDrawerFooter');
    const $drawer = $('#takeActionDrawer');

    // Show loading spinner in body
    $body.html(`
    <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100%;">
      <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Fetching data...</span>
      </div>
      <div class="mt-3">Fetching data...</div>
    </div>
  `);

    $footer.html(`
        <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="offcanvas">Close</button>
    `);

    // Initialize offcanvas with options to disable outside close and ESC
    const drawerInstance = bootstrap.Offcanvas.getInstance($drawer[0]) || new bootstrap.Offcanvas($drawer[0], {
        backdrop: 'static',
        keyboard: false,
        scroll: false
    });

    drawerInstance.show();

    // Simulate dynamic content load
    setTimeout(() => {

        // Load content dynamically
        $.ajax({
            url: fetchDataUrl, // replace with your actual endpoint
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            data: { id: actionId, actionType: actionType },
            success: function (response) {
                // Example response: { image: '', name: '', content: '' }
                // console.log('response => ', response);

                $header.html(`${response?.headerContent || '<p>No content found.</p>'}`);

                $body.html(`${response?.bodyContent || '<p>No content found.</p>'}`);

                $footer.html(`${response?.footerContent || '<button type="button" class="btn btn-secondary me-2" data-bs-dismiss="offcanvas">Close</button>'}`);
            },
            error: function () {
                $body.html('<p class="text-danger">Failed to load data. Please try again later.</p>');
            }
        });
    }, 2000);
});

// Reset header to placeholder when offcanvas is closed
$('#takeActionDrawer').on('hidden.bs.offcanvas', function () {
    $('#takeActionDrawerHeader').html(`
        <div class="placeholder-glow me-2 flex-shrink-0" style="width: 60px; height: 60px;">
                <span class="placeholder rounded-circle w-100 h-100 d-block"></span>
            </div>

        <div class="flex-grow-1 px-2" style="max-width: 70%;">
            <div class="placeholder-glow">
                <h5 class="offcanvas-title text-truncate m-0">
                    <span class="placeholder col-8"></span>
                </h5>
                <span class="placeholder col-3"></span>
            </div>
        </div>

        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    `);

    // Also clear body and footer if needed
    $('#takeActionDrawerBody').html(`
        <div class="placeholder-glow">
            <p><span class="placeholder col-8"></span></p>
            <p><span class="placeholder col-6"></span></p>
        </div>
    `);

    $('#takeActionDrawerFooter').html('');
});




function camelCaseToTitleCase(camelCaseString) {
    return camelCaseString.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); });
}
function populateTable(params) {
    let tableBody = document.getElementById("detailsTableBody");
    // Clear the table body in case it was previously populated
    tableBody.innerHTML = "";
    // If there are no objects in the data, return
    if (params.length === 0) {
        return;
    }
    let fieldNames = Object.keys(params[0].data);
    fieldNames.push('createdAt')
    fieldNames.push('createdBy')
    fieldNames.unshift('Sno');

    // Create the table header row dynamically
    let tableHeader = document.getElementById("detailsTableHeader"); // Get the existing header row
    tableHeader.innerHTML = ""; // Clear the existing header content
    fieldNames.forEach(function (fieldName) {
        let headerCell = document.createElement("th");
        headerCell.textContent = camelCaseToTitleCase(fieldName);
        tableHeader.appendChild(headerCell); // Append the header cells to the header row
    });
    // Loop through the data array and add rows to the table
    // params.forEach(function (item, index) {
    //     let rowData = item.data;
    //     rowData.createdAt = moment(item.created_at).format('DD MMM YYYY hh:mm A')
    //     rowData.createdBy = item.created_by
    //     rowData.Sno = index + 1;
    //     let row = document.createElement("tr");
    //     // Create table cells for each field name in the data object
    //     fieldNames.forEach(function (fieldName) {
    //         let cell = document.createElement("td");
    //         cell.textContent = rowData[fieldName] || ""; // Handle missing fields
    //         row.appendChild(cell);
    //     });
    //     // Append the row to the table body
    //     tableBody.appendChild(row);
    // });
}

let headersName
let csvTemplateName
function showModalDetails(rowData) {
    if (rowData.title != undefined) {
        let formName = 'Import - ' + rowData.title
        csvTemplateName = rowData.title.replace(/\s/g, '_').toLowerCase();
        window.headersName = rowData.data_definition
        window.formMaster_id = rowData.id
        document.getElementById('importLabel').innerHTML = formName
    } else {
        populateTable(JSON.parse(rowData));
    }
}

function generateCsv() {
    let csvContent = '';
    let headersArray
    if (formMasterdata == null) {
        headersArray = JSON.parse(headersName);
    }
    else {
        headersArray = formMasterdata;

    }
    // Add the header names to the CSV content
    headersArray.forEach(function (item) {
        if (item.input == true) {
            csvContent += item.key + ',';
        }

    });
    csvContent += '\n'; // Add a new line after the header names
    return csvContent;
}

let downloadButton = document.getElementById('download-button');

if (downloadButton) {
    downloadButton.addEventListener('click', function () {
        // let csvContent = generateCsv();
        // let blob = new Blob([csvContent], {
        //     type: 'text/csv'
        // });
        // let url = URL.createObjectURL(blob);
        // let downloadLink = document.createElement('a');
        // downloadLink.href = url;
        // downloadLink.download = `${csvTemplateName}.csv`;
        // document.body.appendChild(downloadLink);
        // downloadLink.click();
        // document.body.removeChild(downloadLink);

        exportCSV();
    });
}

function updateFileName(input) {
    let fileName = input.files[0].name;
    let fileLabel = document.getElementById('fileInputLabel');
    fileLabel.innerText = fileName;
    if (fileName) {
        let proceedButton = document.getElementById('uploadcsvData');
        proceedButton.disabled = false
    }
}
function resetState() {
    $('#errorText').addClass('d-none');
    $('#loader').removeClass('spinner-border spinner-border-sm');
    const proceedButton = document.getElementById('uploadcsvData');
    proceedButton.disabled = false;
    const fileLabel = document.getElementById('fileInputLabel');
    const fileInput = document.getElementById('InputFile');
    // Reset the value of the file input
    fileInput.value = '';
    fileLabel.innerText = 'Choose File';
}
let close = document.getElementById('closepopup');
if (close) {
    close.addEventListener('click', resetState)
}
let cancelpopup = document.getElementById('cancelpopup');
if (cancelpopup) {
    cancelpopup.addEventListener('click', resetState)
}
// Get the "Proceed" button element
const proceedButton = document.getElementById('uploadcsvData');
// Add click event listener to the "Proceed" button
if (proceedButton) {
    proceedButton.addEventListener('click', function () {
        // Get the file input element
        const fileInput = document.getElementById('InputFile');

        // Check if a file is selected
        if (!fileInput.checkValidity()) {
            // Trigger the default required validation
            fileInput.reportValidity();
            return;
        } else {
            let proceedButton = document.getElementById('uploadcsvData');
            proceedButton.disabled = true
            $('#loader').addClass('spinner-border spinner-border-sm');
        }

        const Importfile = fileInput.files[0];
        const formMasterId = formMaster_id;
        let formData = new FormData();
        formData.append('_token', $("meta[name='csrf-token']").attr('content')); // Add CSRF token here
        formData.append('file', Importfile);
        formData.append('form_master_id', formMasterId);
        $.ajax({
            type: 'POST',
            url: window.Routes.importCsvUrl ?? '',
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function (response) {
                if (response.success == false) {
                    let errors = response.errors;
                    let errorTitle = 'Oops... Error occurred!';
                    let errorMessages = '';
                    // Loop through the errors and format them
                    if (response.headerError == false) {
                        let errorMessage = '<p class="text-bold">' + response.message + '</p>';
                        errorMessages += errorMessage;
                    } else {
                        if (errors.length == 0) {
                            let errorMessage = '<p class="text-bold">' + response.message + '</p>';
                            errorMessages += errorMessage;
                            const proceedButton = document.getElementById('uploadcsvData');
                            proceedButton.disabled = true
                        } else {
                            if (response.message == undefined) {
                                response.message = ""
                            }
                            let errorMessage = '<p class="text-bold">' + response.message + '</p>';
                            errorMessages += errorMessage;
                            const proceedButton = document.getElementById('uploadcsvData');
                            proceedButton.disabled = true
                            for (let key in errors) {
                                if (errors.hasOwnProperty(key)) {
                                    // Format each error message
                                    // let errorMessage = '<p class="text-bold"> ' + errors[key]+'</p>';
                                    let errorMessage = '<ul><li>' + errors[key] + '</li></ul>';
                                    errorMessages += errorMessage;
                                }
                            }
                        }
                    }
                    // Update the modal with the formatted error message and show it
                    $('#errorText').html(errorMessages).removeClass('d-none');
                    $('#loader').removeClass('spinner-border spinner-border-sm');
                } else {
                    $('#loader').removeClass('spinner-border spinner-border-sm');
                    const closeImportModal = document.getElementById('cancelpopup')
                    closeImportModal.click()
                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: response.message,
                        allowOutsideClick: false,
                    })

                }
            },
            error: function (error) {
                // Show error message
                $('#loader').removeClass('spinner-border spinner-border-sm');
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'An error occurred!',
                });
            }
        });
    });
}


$(document).on('input change', '.remarks-ta, .action-dd', function () {
    // console.log('change', this);
    validateEvaluationForm();

});

function validateEvaluationForm() {

    // console.log('validateEvaluationForm');
    let isValid = true;
    const regex = /^[a-zA-Z0-9\s'#_,.-]+$/;

    $('.remarks-ta').each(function () {
        const $textarea = $(this);
        const value = $textarea.val().trim();
        const index = $textarea.data('index');
        const errorSpan = $('#remarks-ta-' + index + '-error');

        if (value === '') {
            errorSpan.text('Remarks are required.');
            isValid = false;
        } else if (value.length < 10) {
            errorSpan.text('Remarks must be at least 10 characters.');
            isValid = false;
        } else if (value.length > 255) {
            errorSpan.text('Remarks must not exceed 255 characters.');
            isValid = false;
        } else if (!regex.test(value)) {
            errorSpan.text("Only letters, numbers, and - ' # _ , . are allowed.");
            isValid = false;
        } else {
            errorSpan.text('');
        }
    });

    $('.action-dd').each(function () {
        const $select = $(this);
        const value = $select.val();
        const index = $select.data('index');
        const errorSpan = $('#action-dd-' + index + '-error');

        if (!value) {
            errorSpan.text('Please select an action.');
            isValid = false;
        } else {
            errorSpan.text('');
        }
    });

    $('#evaluation-form-submit').toggleClass('disabled', !isValid).prop('disabled', !isValid);
    return isValid;
}

// SweetAlert confirmation on submit
$(document).on('click', '#evaluation-form-submit', function (e) {
    e.preventDefault();

    if (!validateEvaluationForm()) {
        return; // Prevent submission if validation fails
    }

    Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to submit this evaluation?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Submit',
        cancelButtonText: 'Cancel',
        customClass: {
            confirmButton: 'btn btn-success me-2',
            cancelButton: 'btn btn-secondary'
        },
        buttonsStyling: false
    }).then((result) => {
        if (result.isConfirmed) {
            // You can submit your form here
            // Example: $('#your-form-id').submit();

            let formData = $('#cp-evaluation-form').serialize();
            let formSubmissionUrl = $('#evaluation-form-submit').data('url');
            $.ajax({
                url: formSubmissionUrl, // 🔁 Replace with your route
                method: 'POST',
                data: formData,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                success: function (response) {
                    if (response.success) {
                        Swal.fire('Success', response.message, 'success');
                        // 👇 Replace ag-Grid section with updated HTML

                        // if (response?.revised_data) {
                        //     $('#ag-grid-wrapper').html(response.html);
                        // }

                        if (response?.entryIdsToDelete) {
                            removeRowsByEntryIds(response?.entryIdsToDelete);
                        }
                        // 👇 Close the offcanvas/modal if needed
                        $('.offcanvas').offcanvas('hide');
                    } else {
                        Swal.fire('Error', response.message || 'Something went wrong', 'error');
                    }
                },
                error: function (xhr) {
                    Swal.fire('Error', 'Server error occurred. Please try again.', 'error');
                }
            });
            // Swal.fire('Submitted!', 'Evaluation has been submitted.', 'success');
        }
    });
});

// SweetAlert confirmation on submit
$(document).on('click', '.save-review-request', function (e) {
    e.preventDefault();

    // console.log('SweetAlert confirmation on submit');

    const entryId = $(this).data('action-id');
    const saveRequestUrl = $(this).data('url');

    // console.log('entryId => ', entryId);
    if (entryId) {
        // Find the full row object by entryId
        let rowData;
        gridOptions.api.forEachNode((node) => {
            // console.log("NODE DATA => ", node?.data);
            if (node.data.entryptedActionId === entryId) {
                rowData = node.data;
            }
        });

        // console.log('ROW DATA ', rowData)
        if (rowData) {
            showReviewConfirmation(rowData, saveRequestUrl);
        }
    }
});

$(document).on('click', '#bulk-accept-btn, #bulk-reject-btn', function (e) {
    e.preventDefault();

    // console.log('BULK ACCEPT');

    const selectedRows = gridOptions.api.getSelectedRows();
    const selectedCount = selectedRows.length;
    const entryIds = selectedRows.map(row => row.entryptedActionId);

    const formSubmissionUrl = $(this).data('url') ?? '';
    const actionValue = $(this).data('action') ?? '';

    // console.log('Selected rows count:', selectedCount);
    // console.log('Selected rows count:', entryIds);

    if (selectedCount <= 0) {
        let errorResMessage = actionValue.toLowerCase() === 'accepted' ? 'No course preference is selected for the accept.' : 'No course preference is selected for the rejection.';
        Swal.fire('Error', errorResMessage, 'error');
    } else {


        const tableHtml = `
            <form id="review-form">
                <p>Are you sure you want to ${actionValue.toLowerCase() === 'accepted' ? 'accept' : 'reject'} <strong><span id="bulkCount">${selectedCount}</span></strong> course preference(s)?</p>
                <div class="mb-2 text-start">
                <label for="remarks" class="form-label">Remarks <span class="text-danger">*</span></label>
                <textarea id="remarks" class="form-control" rows="3" maxlength="255" placeholder="Enter remarks between 10 and 255 characters..." required></textarea>
                <div id="remarks-error" class="text-danger mt-1"></div>
                </div>
            </form>
            `;
        Swal.fire({
            title: `Confirm Bulk ${actionValue.toLowerCase() === 'accepted' ? 'Accept' : 'Reject'}`,
            html: tableHtml,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            customClass: {
                popup: 'w-50 fs-12',
                htmlContainer: 'text-start',
                confirmButton: 'btn btn-warning me-2',
                cancelButton: 'btn btn-secondary'
            },
            buttonsStyling: false,
            preConfirm: () => {
                const remarks = document.getElementById('remarks').value.trim();
                const remarksError = document.getElementById('remarks-error');

                // Validate
                if (remarks.length < 10 || remarks.length > 255) {
                    remarksError.textContent = 'Remarks must be between 10 and 255 characters.';
                    return false;
                }

                const regex = /^[a-zA-Z0-9 '#_,.-]+$/;
                if (!regex.test(remarks)) {
                    remarksError.textContent = "Only letters, numbers, and - ' # _ , . are allowed.";
                    return false;
                }

                remarksError.textContent = ''; // clear error

                return new Promise((resolve) => {
                    $.ajax({
                        url: formSubmissionUrl,
                        method: 'POST',
                        data: {
                            entryIds: entryIds,
                            actionType: 'bulk',
                            actions: actionValue,
                            remarks: remarks,
                        },
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        },
                        success: function (response) {
                            if (response?.entryIdsToDelete) {
                                removeRowsByEntryIds(response?.entryIdsToDelete);
                            }
                            Swal.fire('Success', response?.message ?? 'Review request submitted.', 'success');
                            resolve();
                        },
                        error: function () {
                            Swal.fire('Error', response?.message ?? 'Something went wrong.', 'error');
                        }
                    });
                });
            }
        });
    }


    // const entryId = $(this).data('action-id');
    // const saveRequestUrl = $(this).data('url');

    // console.log('entryId => ', entryId);
    // if (entryId) {
    //     // Find the full row object by entryId
    //     let rowData;
    //     gridOptions.api.forEachNode((node) => {
    //         console.log("NODE DATA => ", node?.data);
    //         if (node.data.entryptedActionId === entryId) {
    //             rowData = node.data;
    //         }
    //     });

    //     console.log('ROW DATA ', rowData)
    //     if (rowData) {
    //         showReviewConfirmation(rowData, saveRequestUrl);
    //     }
    // }
});

// Get activity logs
$(document).on('click', '.show-activity-log', function (e) {
    e.preventDefault();

    // console.log('show-activity-log');
    const showActivityLogUrl = $(this).data('url');



    // console.log('showActivityLogUrl => ', showActivityLogUrl);
    if (showActivityLogUrl) {
        // // Find the full row object by entryId
        // let rowData;
        // gridOptions.api.forEachNode((node) => {
        //     console.log("NODE DATA => ", node?.data);
        //     if (node.data.entryptedActionId === entryId) {
        //         rowData = node.data;
        //     }
        // });

        // console.log('ROW DATA ', rowData)
        // if (rowData) {
        //     showReviewConfirmation(rowData, saveRequestUrl);
        // }

        $.ajax({
            url: showActivityLogUrl,
            method: 'POST',
            data: {
                action: 'SHOW_ACTIVITY_LOG',
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            success: function (response) {
                if (response?.activityLogs?.length) {
                    showActivityCards(response?.activityLogs, response?.coursePreferenceData);
                }
                // Swal.fire('Success', response?.message ?? 'Review request submitted.', 'success');
                // resolve();
            },
            error: function () {
                Swal.fire('Error', response?.message ?? 'Something went wrong.', 'error');
            }
        });
    }
});
// $('body').on('click', '.deleteEle', function () {

document.addEventListener("DOMContentLoaded", function () {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });
});

// var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
// var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
//     return new bootstrap.Dropdown(dropdownToggleEl);
// });

function removeRowsByEntryIds(entryIds) {
    const rowsToRemove = [];
    gridOptions.api.forEachNode((node) => {
        if (entryIds.includes(node.data.entry_id)) {
            rowsToRemove.push(node.data);
        }
    });

    gridOptions.api.applyTransaction({ remove: rowsToRemove });
}

function showReviewConfirmation(rowData, saveRequestUrl) {
    // console.log('showReviewConfirmation => ', rowData);

    const tableHtml = `
      <form id="review-form">
        <table class="table table-bordered text-start mb-3">
          <tr><th>Application Number</th><td>${rowData.applicationNumber}</td></tr>
          <tr><th>Candidate Name</th><td>${rowData.title + ' ' + rowData.firstName + ' ' + (rowData?.middleName ?? '') + ' ' + (rowData?.lastName ?? '')}</td></tr>
          <tr><th>Course Applied</th><td>${rowData.courseName}</td></tr>
          <tr><th>Percentage</th><td>${rowData.aggregatePercentage}</td></tr>
          <tr><th>Status</th><td>${rowData.overall_status}</td></tr>
        </table>
        <div class="mb-2 text-start">
          <label for="remarks" class="form-label">Remarks <span class="text-danger">*</span></label>
          <textarea id="remarks" class="form-control" rows="3" maxlength="255" placeholder="Enter remarks between 10 and 255 characters..." required></textarea>
          <div id="remarks-error" class="text-danger mt-1"></div>
        </div>
      </form>
    `;

    Swal.fire({
        title: 'Confirm Review Request',
        html: tableHtml,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        customClass: {
            popup: 'w-50 fs-12',
            htmlContainer: 'text-start',
            confirmButton: 'btn btn-warning me-2',
            cancelButton: 'btn btn-secondary'
        },
        buttonsStyling: false,
        preConfirm: () => {
            const remarks = document.getElementById('remarks').value.trim();
            const remarksError = document.getElementById('remarks-error');

            // Validate
            if (remarks.length < 10 || remarks.length > 255) {
                remarksError.textContent = 'Remarks must be between 10 and 255 characters.';
                return false;
            }

            const regex = /^[a-zA-Z0-9 '#_,.-]+$/;
            if (!regex.test(remarks)) {
                remarksError.textContent = "Only letters, numbers, and - ' # _ , . are allowed.";
                return false;
            }

            remarksError.textContent = ''; // clear error

            return new Promise((resolve) => {
                $.ajax({
                    url: saveRequestUrl,
                    method: 'POST',
                    data: {
                        entryIds: [rowData?.entryptedActionId],
                        action: 'REVIEW_REQUEST',
                        remarks: remarks,
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },
                    success: function (response) {
                        if (response?.entryIdsToDelete) {
                            removeRowsByEntryIds(response?.entryIdsToDelete);
                        }
                        Swal.fire('Success', response?.message ?? 'Review request submitted.', 'success');
                        resolve();
                    },
                    error: function () {
                        Swal.fire('Error', response?.message ?? 'Something went wrong.', 'error');
                    }
                });
            });
        }
    });
}

function showActivityCards(activityLogs, coursePreferenceData) {
    // const logs = [
    //     {
    //         status: 'Completed',
    //         remarks: 'Report downloaded successfully',
    //         by: 'John Doe',
    //         time: '2025-05-28 10:00 AM'
    //     },
    //     {
    //         status: 'Pending',
    //         remarks: 'Waiting for approval',
    //         by: 'Jane Smith',
    //         time: '2025-05-28 10:15 AM'
    //     },
    //     {
    //         status: 'Failed',
    //         remarks: 'Download failed due to timeout',
    //         by: 'Admin',
    //         time: '2025-05-28 10:30 AM'
    //     }
    // ];

    const getStatusBadge = (status) => {
        switch (status.toLowerCase()) {
            case 'submitted': return `<span class="badge bg-gradient bg-primary position-absolute top-0 end-0 mt-1 me-1">${status}</span>`;
            case 'academic_accepted': return `<span class="badge bg-gradient bg-success position-absolute top-0 end-0 mt-1 me-1">${status}</span>`;
            case 'academic_rejected': return `<span class="badge bg-gradient bg-danger position-absolute top-0 end-0 mt-1 me-1">${status}</span>`;
            case 'hod_accepted': return `<span class="badge bg-gradient bg-success position-absolute top-0 end-0 mt-1 me-1">${status}</span>`;
            case 'hod_rejected': return `<span class="badge bg-gradient bg-danger position-absolute top-0 end-0 mt-1 me-1">${status}</span>`;
            case 'dean_accepted': return `<span class="badge bg-gradient bg-success position-absolute top-0 end-0 mt-1 me-1">${status}</span>`;
            case 'dean_rejected': return `<span class="badge bg-gradient bg-danger position-absolute top-0 end-0 mt-1 me-1">${status}</span>`;
            default: return `<span class="badge bg-gradient bg-warning position-absolute top-0 end-0 mt-1 me-1">${status}</span>`;
        }
    };

    const getBgClassName = (status) => {
        switch (status.toLowerCase()) {
            case 'submitted': return `bg-primary`;
            case 'academic_accepted': return `bg-success`;
            case 'academic_rejected': return `bg-danger`;
            case 'hod_accepted': return `bg-success`;
            case 'hod_rejected': return `bg-danger`;
            case 'dean_accepted': return `bg-success`;
            case 'dean_rejected': return `bg-danger`;
            default: return `bg-warning`;
        }
    };

    let timelineHtml = activityLogs.map(item => `
    <div class="timeline-item mb-4">
      <div class="timeline-icon  ${getBgClassName(item.status)}">${item.initials}</div>
      <div class="card">
        <div class="card-body">
            ${getStatusBadge(item.status)}
            <small class="text-muted d-block mt-1"><i class="fas fa-user"> </i> ${item.by}</small>
            <small class="text-muted d-block mt-1"> <i class="fas fa-paragraph"> </i> ${item.remarks} </small>          
            <small class="text-muted d-block mt-1"> <i class="fas fa-clock"> </i> ${item.time} </small>
        </div>
      </div>
    </div>
  `).join('');

    Swal.fire({
        title: `<h5 class="fw-bold mb-1">Activity Logs</h5>
                <small class="float-left fs-6 text-left">
                    <span class="fst-italic">Application Number:</span> <strong>${coursePreferenceData?.applicationNumber ?? 'NA'}</strong>
                    <span class="fst-italic">Candidate Name:</span> <strong>${[coursePreferenceData?.title, coursePreferenceData?.firstName, coursePreferenceData?.middleName, coursePreferenceData?.lastName].filter(Boolean).join(' ')}</strong>
                    <span class="fst-italic">Course Applied:</span> <strong>${coursePreferenceData?.courseName ?? 'NA'}</strong>
                    <span class="fst-italic">Percentage:</span> <strong>${coursePreferenceData?.aggregatePercentage ?? 'NA'}</strong>
                </small>`,
        html: `
      <div class="overflow-auto" style="max-height: 300px; text-align: left;">
        <div class="timeline position-relative ps-4 mt-3">
          ${timelineHtml}
        </div>
      </div>
    `,
        customClass: {
            popup: 'p-3 w-50',
            title: 'mb-1 border-bottom',
            confirmButton: 'btn btn-secondary'
        },
        showCloseButton: true,
        confirmButtonText: 'Close',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
            document.body.style.overflow = 'hidden'; // Disable background scroll
        },
        willClose: () => {
            document.body.style.overflow = ''; // Re-enable background scroll
        }
    });

    // const htmlContent = `
    //      <div class="modal-content border-0">
    //         <!-- Header -->
    //         <div class="modal-header border-bottom">
    //             <div class=" text-left">
    //                 <h5 class="modal-title fw-bold mb-0">Activity Logs</h5>
    //                 <small class="text-muted">
    //                     <span class="fst-italic">Application Number:</span> <strong> ${coursePreferenceData?.applicationNumber}</strong>
    //                     <br>
    //                     <span class="fst-italic">Candidate Name:</span> <strong> ${coursePreferenceData?.title ?? ''} ${coursePreferenceData?.firstName ?? ''} ${coursePreferenceData?.middleName ?? ''} ${coursePreferenceData?.lastName ?? ''}</strong>
    //                     <br>
    //                     <span class="fst-italic">Course Applied:</span> <strong> ${coursePreferenceData.courseName}</strong>
    //                     <br>
    //                     <span class="fst-italic">Percentage:</span> <strong> ${coursePreferenceData.aggregatePercentage}</strong>
    //                 </small>
    //             </div>
    //         </div>
    //         <!-- Body -->
    //         <div class="modal-body">
    //             ${activityLogs.map(log => `
    //                 <div class="activity-card">
    //                     <div class="d-flex justify-content-between align-items-center mb-2">
    //                         <div class="status">${getStatusBadge(log.status)}</div>
    //                         <div class="text-muted small d-flex align-items-center">
    //                         <i class="bi bi-clock me-1"></i> ${log.time}
    //                         </div>
    //                     </div>

    //                     <div class="remarks mb-2 text-left">
    //                         <i class="bi bi-chat-dots me-1 text-primary"></i>
    //                         <span class="fst-italic">Remarks:</span> <strong> ${log.remarks}</strong>
    //                     </div>

    //                     <div class="by text-left">
    //                         <i class="bi bi-person-circle me-1 text-secondary"></i>
    //                         <span class="fst-italic">Actioned by:</span> <strong> ${log.by}</strong>
    //                     </div>
    //                 </div>
    //             `).join('')}
    //         </div>

    //         <!-- Footer -->
    //         <!--div class="modal-footer border-top justify-content-end">
    //             <button type="button" class="btn btn-secondary" data-swal2-close>Close</button>
    //             <button type="button" class="btn btn-secondary swal2-close" aria-label="Close this dialog" style="display: flex;">Close</button>
    //         </div-->
    //     </div>
    // `;

    // Swal.fire({
    //     html: htmlContent,
    //     showConfirmButton: false,
    //     showCloseButton: true,
    //     allowOutsideClick: false,
    //     customClass: {
    //         popup: 'p-0 ws-50',
    //         confirmButton: 'btn btn-secondary mt-2'
    //     }
    // });
}